import React from "react";
import { Link } from "react-router-dom";
import { bool, func, string } from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Grid from "@material-ui/core/Grid";
import { Button, InputLabel, Switch } from "@material-ui/core";
import brandTheme from "../../../brandTheme/Theme";
import CustomeTextField from "../CustomeTextField";
import CustomSelectNew from "components/UpdateUi/CustomeSelect";
import { toCamelCase } from "utils/Utils";
import FilterDialog from "./FilterDialog";
import DateFilter from "./DateFilter";
const useStyles = makeStyles((theme) => ({
  mainContainer: {
    marginBottom: "17px",
    borderBottom: `1px solid ${brandTheme.mainColor}`,
    paddingBottom: "1.5%",
    marginTop: "10px",
    display: "flex",
    justifyContent: "space-between",
    "@media (max-width:600px)": {
      textAlign: "center",
      display: "block",
    },
  },
  onlyButtonContainer: {
    borderBottom: "inherit",
    padding: "0px",
  },

  button: {
    backgroundColor: brandTheme.buttonColor,
    color: brandTheme.white,
    borderRadius: "10px",
    padding: "10px 15px",
    minWidth: "140px",

    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },

    [theme.breakpoints.down("sm")]: {
      minWidth: "120px",
      width: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      minWidth: "120px",
      width: "100%",
      margin: "15px",
    },
  },

  label: {
    fontSize: brandTheme.headerFontSize,
    fontWeight: 700,
    lineHeight: "1.5rem",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    fontFamily: brandTheme.font.poppins,

    [theme.breakpoints.down("sm")]: {
      padding: 0,
      marginBottom: "15px",
      fontSize: brandTheme.headerFontSizeMobile,
    },
    [theme.breakpoints.down("xs")]: {
      padding: 0,
      marginBottom: "15px",
      fontSize: brandTheme.headerFontSizeMobile,
      justifyContent: "center",
      alignItems: "center",
      margin: "10px",
    },
  },

  subLabel: {
    fontSize: brandTheme.textFontSize,
    fontWeight: 700,
    lineHeight: "1.5rem",
    display: "flex",
    alignItems: "center",
    paddingLeft: "4px",
    marginTop: "10px",
    fontFamily: brandTheme.font.poppins,

    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      padding: 0,
      marginBottom: "10px",
    },
  },

  spamText: {
    fontWeight: 700,
    lineHeight: "1.5rem",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    fontFamily: brandTheme.font.poppins,

    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      paddingLeft: 0,
      textAlign: "center",
    },
  },

  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    fontFamily: brandTheme.font.poppins,
    // paddingRight: "5%",
    gap: "15px",
    // marginTop: "15px",
    flexWrap: "wrap",

    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
      paddingRight: 0,
      gap: "10px",
    },
  },

  button2: {
    minWidth: "140px",
    backgroundColor: brandTheme.button2Color,

    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },

    [theme.breakpoints.down("sm")]: {
      minWidth: "120px",
      width: "100%",
    },
  },

  fieldContaienr: {
    margin: "20px 10px 0px 10px",
    maxWidth: "29.3%",

    "@media (min-width:600px) and (max-width:960px)": {
      maxWidth: "48%",
      flex: "0 0 48%",
    },

    [theme.breakpoints.down("sm")]: {
      maxWidth: "94%",
      margin: "10px 10px",
      flex: "0 0 100%",
    },
  },

  toggleContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: "15px",

    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      width: "100%",
      marginTop: "10px",
      marginRight: 0,
    },
  },
  searchContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },

  dateFilterWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "100%",
    padding: "0 15px",
    boxSizing: "border-box",
  },

  dateFilterContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "12px",
    width: "100%",
    flexWrap: "nowrap",

    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      flexWrap: "wrap",
    },
  },

  dateField: {
    width: "40%",

    [theme.breakpoints.down("sm")]: {
      width: "200px",
    },

    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },

  searchButton: {
    backgroundColor: brandTheme.buttonColor,
    color: brandTheme.white,
    borderRadius: "10px",
    padding: "10px 25px",
    height: "56px",
    minWidth: "125px",

    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },

    "&:disabled": {
      opacity: 0.6,
    },

    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },

  dateError: {
    color: brandTheme.errorColor || "#f44336",
    fontSize: "13px",
    marginTop: "5px",
    textAlign: "right",
  },
}));

const SubHeader = ({
  label,
  button1,
  button2,
  disabled1,
  disabled2,
  button1click,
  button2click,
  searchLabel,
  search,
  onSearchChange,
  message,
  colorFlag,
  onlyLabel,
  selectInput,
  selectLabel,
  selectData,
  handleSelectChange,
  selectValue,
  subLabel,
  searchCriteria,
  handleFromDateChange,
  fromDate,
  handleToDateChange,
  toDate,
  toggleEnabled,
  toggleValue,
  toggleDisabled,
  onToggleChange,
  toggleLabelLeft,
  toggleLabelRight,
  tab = "",
  withRightText,
  buttonClick,
}) => {
  // const [openFilter, setOpenFilter] = React.useState(false);
  const classes = useStyles();
  const gridColumns = tab !== "" ? 6 : withRightText ? 8 : 4;
  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      className={
        tab !== ""
          ? `${classes.mainContainer} ${classes.onlyButtonContainer}`
          : classes.mainContainer
      }
    >
      <Grid container>
        <Grid
          item
          xs={12}
          sm={onlyLabel ? 12 : searchCriteria ? 3 : withRightText ? 8 : 4}
          md={onlyLabel ? 12 : searchCriteria ? 3 : gridColumns}
          className={classes.label}
        >
          {label && toCamelCase(label)}
          {subLabel && <span className={classes.subLabel}> [{subLabel}]</span>}
        </Grid>
        {toggleEnabled && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: "15px",
            }}
          >
            <InputLabel style={{ marginRight: "8px" }}>
              {toggleLabelLeft || "No"}
            </InputLabel>
            <Switch
              checked={toggleValue}
              onChange={onToggleChange}
              color="primary"
              disabled={toggleDisabled}
            />
            <InputLabel style={{ marginRight: "8px" }}>
              {toggleLabelRight || "Yes"}
            </InputLabel>
          </div>
        )}
        {selectInput && (
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            className={classes.fieldContaienr}
            style={{ marginTop: "10px" }}
          >
            <CustomSelectNew
              label={selectLabel}
              id={selectLabel}
              value={selectValue}
              setState={handleSelectChange}
              data={selectData}
              type="type"
            />
          </Grid>
        )}
        {message ||
          (search && (
            <Grid
              item
              xs={12}
              sm={message ? 8 : 3}
              md={message ? 8 : 3}
              className={classes.label}
            >
              {message && (
                <span
                  className={classes.spamText}
                  style={{
                    color: colorFlag ? brandTheme.errorColor : brandTheme.green,
                    fontSize: "14px",
                    fontStyle: "italic",
                  }}
                >
                  {message}
                </span>
              )}
              {search && (
                <CustomeTextField
                  label={searchLabel}
                  onchange={onSearchChange}
                  search={search}
                />
              )}
            </Grid>
          ))}
        {searchCriteria && (
          <Grid
            item
            xs={12}
            sm={12}
            md={5}
            className={classes.dateFilterWrapper}
          >
            <DateFilter
              classes={classes}
              fromDate={fromDate}
              toDate={toDate}
              handleFromDateChange={handleFromDateChange}
              handleToDateChange={handleToDateChange}
              handleDateSearch={(filters) => {
                if (buttonClick) {
                  buttonClick(filters);
                }
              }}
              searchButtonLabel="SEARCH"
              disabledSearch={disabled1 || disabled2}
            />
          </Grid>
        )}

        {(button1 || button2) && (
          <Grid
            item
            xs={12}
            sm={4}
            md={search ? 4 : searchCriteria ? 4 : 6}
            className={classes.buttonContainer}
            id="buttonContainer"
          >
            {/* {searchCriteria &&
        <Button
          className={classes.button}
          onClick={() => setOpenFilter(true)}
        >
          Filters
        </Button>
        } */}
            {button1 && (
              <Button
                className={classes.button}
                disabled={disabled1}
                onClick={() => button1click()}
                id="button"
              >
                {button1}
              </Button>
            )}
            {button2 && (
              <Button
                className={`${classes.button2} ${classes.button}`}
                disabled={disabled2}
                onClick={() => button2click()}
                id="button"
              >
                {button2}
              </Button>
            )}
          </Grid>
        )}
        {/* <FilterDialog
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          fromDate={fromDate}
          toDate={toDate}
          handleFromDateChange={handleFromDateChange}
          handleToDateChange={handleToDateChange}
          onApply={(filters) => {
          setOpenFilter(false);

          if (buttonClick) {
            buttonClick(filters);   // or buttonClick(filters)
          }
        }}
        /> */}
      </Grid>
    </Grid>
  );
};

SubHeader.propTypes = {
  label: string,
  button1: string,
  button2: string,
  disabled1: bool,
  disabled2: bool,
  button1click: func,
  button2click: func,
  searchLabel: string,
  search: bool,
  onSearchChange: func,
  toggleEnabled: bool,
  toggleValue: bool,
  toggleDisabled: bool,
  onToggleChange: func,
  toggleLabelLeft: string,
  toggleLabelRight: string,
};
export default SubHeader;
